import { computed, reactive } from 'vue';

const state = reactive({
  instances: {},
});

export function usePaginator({ id }) {
  if (!state.instances[id]) {
    state.instances[id] = {
      items: [],
      currentItem: undefined,
    };
  }

  const registerItem = item => {
    if (state.instances[id].items.includes(item)) return;
    state.instances[id].items.push(item);
  };

  const items = computed(() => {
    return state.instances[id].items;
  });

  const itemsLength = computed(() => {
    return items.value.length;
  });

  const currentItem = computed(() => {
    return state.instances[id].currentItem;
  });

  const currentIndex = computed(() => {
    return items.value.indexOf(currentItem.value);
  });

  const setCurrentItem = item => {
    state.instances[id].currentItem = item;
  };

  const next = () => {
    const nextIndex =
      currentIndex.value + 1 >= itemsLength.value ? 0 : currentIndex.value + 1;
    const nextItem = items.value[nextIndex];
    setCurrentItem(nextItem);
  };

  const previous = () => {
    const previousIndex =
      currentIndex.value - 1 < 0
        ? itemsLength.value - 1
        : currentIndex.value - 1;
    const previousItem = items.value[previousIndex];
    setCurrentItem(previousItem);
  };

  return {
    registerItem,
    items,
    itemsLength,
    setCurrentItem,
    currentItem,
    currentIndex,
    next,
    state,
    previous,
  };
}
